// extracted by mini-css-extract-plugin
export default {"root":"AppLayout_root__1Zmup","sidebarWrapper":"AppLayout_sidebarWrapper__JyeOJ","navbarAndContentWrapper":"AppLayout_navbarAndContentWrapper__ci0LJ"};